import * as React from 'react';
import './SelectTableComponent.css';
import { Table } from 'antd';
import { TableProps } from 'antd';
import SelectionComponent from '../../components/SelectionComponent/SelectionComponent';
import { FormattedMessage } from 'react-intl';

const SelectTableComponent: React.FC<Props<any>> = (props: Props<any>) => {
    const { selectedItems, pagination, onUnselectAll, className } = props;

    return (
        <>
            {selectedItems.length > 0 ? (
                <SelectionComponent
                    label={<FormattedMessage id="selectTable.selected" />}
                    items={selectedItems}
                    onClearAll={onUnselectAll}
                />
            ) : (
                <></>
            )}
            <Table {...props} pagination={pagination} className={`select-table ${className}`} />
        </>
    );
};
export default SelectTableComponent;

interface Props<RecordType> extends TableProps<RecordType> {
    selectedItems: React.ReactNode[] | string[];
    onUnselectAll: () => void;
}
